import script from "./BaseSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSwitch.vue?vue&type=script&setup=true&lang=js"

import "./BaseSwitch.vue?vue&type=style&index=0&id=c0906080&lang=scss"

const __exports__ = script;

export default __exports__